import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"

export interface IFairValueFactorsItem {
    monthlySDC: number,
    monthlyStandard: number,
    depreciationRate: number,
    rentalFeesPercentage: number
}

export interface IFairValueFactorsException {
    id: Guid,
    exceptionId: Guid,
    name: string,
    fairValue: IFairValueFactorsItem

}

export interface IFairValueFactors {
    default: IFairValueFactorsItem
    articles?: IFairValueFactorsException[]
    assetCategories?: IFairValueFactorsException[]
    divisions?: IFairValueFactorsException[]
}

export interface IGetFairValueFactorsDto extends IFairValueFactors {
    links: IApiLink[]
}
export interface IPostFairValueFactorsDto extends IFairValueFactorsItem {
    rentalFeesPercentage: number
}

export default class FairValueFactors {
    default?: IFairValueFactorsItem
    articles?: IFairValueFactorsException[]
    assetCategories?: IFairValueFactorsException[]
    divisions?: IFairValueFactorsException[]
    linkCreate?: IApiLink
    linkUpdate?: IApiLink


    constructor(dto: IGetFairValueFactorsDto) {
        this.default = dto.default
        this.articles = dto.articles
        this.assetCategories = dto.assetCategories
        this.divisions = dto.divisions
        this.linkCreate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.fairValueFactors && lnk.rel === ApiLinkRel.new)
        this.linkUpdate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.fairValueFactors && lnk.rel === ApiLinkRel.partialUpdate)
    }
}
